import React, { FC } from 'react';
import { ContentCard, Grid, GridItem } from '@modernhealth/vital-components';
import { ScheduledContentEdge } from 'src/generated/webapp_gql';

import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import { useHistory } from 'react-router-dom';

interface CompletedDailyPausesListProps {
    links: ScheduledContentEdge[];
    setLastElement?: React.Dispatch<React.SetStateAction<HTMLDivElement | null | undefined>>;
}

const ContentCardWrap = styled.div`
    display: flex;
    width: 100%;

    img {
        object-fit: contain;
    }
`;

export const CompletedDailyPausesList: FC<CompletedDailyPausesListProps> = ({
    links,
    setLastElement,
}) => {
    const history = useHistory();

    return (
        <Grid lgMode="5columns">
            {links?.map(({ node }, i) => {
                if (!node) return null;

                return (
                    <GridItem lg={1} md={2} key={node.id}>
                        <ContentCardWrap ref={i === links.length - 1 ? setLastElement : undefined}>
                            <ContentCard
                                title={node.bannerTitle}
                                description={node.mediaType?.name || ''}
                                image={node.bannerImage || ''}
                                backgroundColor={
                                    node.accentColor ? `#${node.accentColor}` : colors.white
                                }
                                id={node.id}
                                testID={`CompletedDailyPauseItem-${i}`}
                                descriptionStartIconUrl={node.mediaType?.icon}
                                isCompleted
                                onClick={() => {
                                    history.push(`/pause/${node.uuid ?? ''}`, {
                                        from: true,
                                    });
                                }}
                            />
                        </ContentCardWrap>
                    </GridItem>
                );
            })}
        </Grid>
    );
};
